import PropTypes from "prop-types"
import React, { useMemo } from "react"
import { FiTrash2 } from "react-icons/fi"
import styled from "styled-components"

import ImageInput from "./ImageInput"

// ----------------------------------------------------------------------------

function _RoomImagePicker(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, value, onChange, error } = props

    const message = error
    const invalid = !!message

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    const mappedImages = useMemo(() => {
        return value?.map((image) =>
            typeof image === "string" ? image : URL.createObjectURL(image)
        )
    }, [value])

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function renderImages() {
        return mappedImages?.map((image, index) => (
            <div className="image" key={image}>
                <img src={image} />
                <div
                    className="delete-btn"
                    onClick={() => {
                        handleDeleteImage(index)
                    }}
                >
                    <FiTrash2 />
                </div>
            </div>
        ))
    }

    function renderAddImage() {
        return <ImageInput onUpload={handleUplad} className="image-input" />
    }

    function handleDeleteImage(index) {
        const newImages = [...value]
        newImages.splice(index, 1)
        onChange(newImages)
    }

    function handleUplad(files) {
        onChange && onChange([...(value ?? []), ...(files ?? [])])
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className} ${invalid && "invalid"}`}>
            <span className="heading">Aggiungi foto</span>
            <div className="images">
                {renderImages()}
                {renderAddImage()}
            </div>
            {invalid && <small className="error-msg">{message}</small>}
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_RoomImagePicker.propTypes = {
    className: PropTypes.string.isRequired,
    value: PropTypes.array,
    onChange: PropTypes.func,
    error: PropTypes.string,
}

_RoomImagePicker.defaultProps = {}

// ----------------------------------------------------------------------------

const RoomImagePicker = styled(_RoomImagePicker)`
    & {
        .heading {
            display: block;
            font-weight: 600;
            font-size: 18px;
            margin-bottom: 10px;
            color: ${({ theme }) => theme.colors.dark};
        }

        .images {
            display: grid;
            grid-template-columns: repeat(auto-fit, 120px);
            grid-template-rows: repeat(auto-fit, minMax(120px, 120px));
            grid-gap: 22px;

            .image {
                width: 100%;
                height: 100%;
                border-radius: 10px;
                overflow: visible;
                min-height: 120px;
                position: relative;

                &:hover {
                    .delete-btn {
                        opacity: 1;
                    }
                }

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 10px;
                }
                .delete-btn {
                    position: absolute;
                    top: -20px;
                    right: -20px;
                    width: 40px;
                    height: 40px;
                    background-color: white;
                    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.2);

                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 100%;
                    opacity: 0;
                    transition: all 200ms ease;

                    cursor: pointer;

                    svg {
                        width: 22px;
                        height: 22px;
                        fill: white;
                        stroke: ${({ theme }) => theme.colors.error};
                    }
                }
            }
            .add-image {
            }
        }
        &.invalid {
            .image-input {
                border-color: ${({ theme }) => theme.colors.error};
                svg {
                    fill: ${({ theme }) => theme.colors.error};
                }
            }
            .error-msg {
                display: block;
                font-weight: 700;
                margin-top: 10px;
                margin-left: 5px;
                color: ${({ theme }) => theme?.colors?.error};
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default RoomImagePicker
